// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"273":"197ec2212190a1e0","533":"6260ca061f1ee8d3"}[chunkId] + ".js";
};